import React, { FunctionComponent, useState } from 'react';
import styles from './tabs-menu.module.scss';
import { NavTabTextItem } from './nav-tab-text-item/nav-tab-text-item';
import { TabContentItem } from './tab-content-item/tab-content-item';
import { TabsNav } from './tabs-nav/tabs-nav';

export interface INavTabTextItemProps {
  text: string;
}

export interface ITabContentItemProps {
  text: string;
  image: {
    url: string;
    descritpion: string;
  };
}

export interface ITabsMenuProps {
  navTabs: INavTabTextItemProps[];
  tabContent: ITabContentItemProps[];
}

export const TabsMenu: FunctionComponent<ITabsMenuProps> = ({
  navTabs,
  tabContent
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [prevTabIndex, setprevTabIndex] = useState(0);
  const [progressLinePostition, setProgressLinePostition] = useState(0);
  const [startAnimating, setStartAnimating] = useState(false);

  const changeTabHandler = (event: React.MouseEvent<HTMLElement>): void => {
    const elem = event.target as HTMLDivElement;
    const newProgressLinePostion = elem.offsetLeft;
    const index = elem.dataset.index || 0;

    event.preventDefault();

    if (+index !== activeTabIndex) {
      setActiveTabIndex(prevState => {
        setprevTabIndex(prevState);
        return +index;
      });
      setProgressLinePostition(newProgressLinePostion);
    }
    setStartAnimating(true);
  };

  return (
    <div className={styles.container}>
      <TabsNav progressLinePostition={progressLinePostition}>
        {navTabs.map((navTab, i) => (
          <NavTabTextItem
            isActive={activeTabIndex === i}
            key={i}
            index={i}
            {...navTab}
            changeTab={changeTabHandler}
          />
        ))}
      </TabsNav>
      <div className={styles.tabsContent}>
        {tabContent.map(
          (tab, i) =>
            i === activeTabIndex && (
              <TabContentItem
                key={i}
                {...tab}
                index={i}
                prevTabIndex={prevTabIndex}
                isAnimated={startAnimating}
              />
            )
        )}
      </div>
    </div>
  );
};
